import { AnimatePresence } from 'framer-motion';
import React, { FunctionComponent, useEffect } from 'react';

import ErrorScreen from 'components/ErrorScreen/ErrorScreen';

import * as Styled from './UnsupportedWindowAspectRatio.styles';

export interface UnsupportedWindowAspectRatioProps {
  isVisible?: boolean;
  setAccept(state: boolean): void;
}

const defaultProps: Partial<UnsupportedWindowAspectRatioProps> = {
  isVisible: false,
};

const UnsupportedWindowAspectRatio: FunctionComponent<
  UnsupportedWindowAspectRatioProps
> = ({ isVisible, setAccept }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <Styled.Wrapper>
          <ErrorScreen
            errorType="unsupportedWindowAspectRatio"
            handleContinueAnyway={setAccept}
          />
        </Styled.Wrapper>
      )}
    </AnimatePresence>
  );
};

UnsupportedWindowAspectRatio.defaultProps = defaultProps;

export default UnsupportedWindowAspectRatio;
